import { Box, Stack, Tooltip } from "@mui/material";
import { useState, useRef, useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
// config
import colors from "../../../config/colors";
// redux
import { useDispatch } from "../../../redux/store";
import { setWishlistCreatorId } from "../../../redux/slices/creator";
// ga
import {
  triggerGa,
  CATEGORY,
  ACTION,
  PAGE,
  SCREEN,
  LABEL,
  LABEL2,
} from "../../../utils/gaUtils";

const Actions = ({ item }) => {
  const dispatch = useDispatch();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const timeoutRef = useRef(null);

  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const handleAddToWishlist = (e) => {
    e.stopPropagation();
    triggerGa({
      category: CATEGORY.USER_INTERACTION,
      action: ACTION.ADD_TO_WISHLIST,
      label: item?.username,
      label2: LABEL2.ATTEMPT,
      label3: LABEL2.PROFILE_INTEREST,
      page: PAGE.CREATOR_DISCOVER,
      screenName: SCREEN.DISCOVER_LIST,
    });
    dispatch(setWishlistCreatorId(item?.wishlink_username));
  };

  const handleTooltipClick = (e) => {
    e.stopPropagation();
    triggerGa({
      category: CATEGORY.USER_INTERACTION,
      action: ACTION.CONTACT_CLICK,
      label: item?.username,
      label2: LABEL2.ATTEMPT,
      label3: LABEL2.PROFILE_INTEREST,
      page: PAGE.CREATOR_DISCOVER,
      screenName: SCREEN.DISCOVER_LIST,
    });
    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (!tooltipOpen) {
      // Show tooltip and set timer to hide it after 2 seconds
      setTooltipOpen(true);
      timeoutRef.current = setTimeout(() => {
        setTooltipOpen(false);
        timeoutRef.current = null;
      }, 2000);
    } else {
      // If already open, close it immediately
      setTooltipOpen(false);
      timeoutRef.current = null;
    }
  };

  return (
    <Stack direction="row" gap={1}>
      <Box
        sx={{
          cursor: "pointer",
          height: "40px",
          width: "40px",
          borderRadius: "8px",
          border: `1px solid ${colors.gray100}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: "12px",
        }}
        data-cy="list-view-add-button"
        onClick={handleAddToWishlist}
      >
        <AddIcon
          sx={{ fontSize: 20, color: colors.primary500, opacity: 0.7 }}
        />
      </Box>
      <Tooltip
        title="Chat coming soon!"
        arrow
        open={tooltipOpen}
        disableFocusListener
        disableHoverListener
        disableTouchListener
      >
        <Box
          sx={{
            cursor: "pointer",
            height: "40px",
            width: "40px",
            borderRadius: "8px",
            border: `1px solid ${colors.gray100}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: "12px",
          }}
          data-cy="list-view-contact-button"
          onClick={handleTooltipClick}
        >
          <EmailOutlinedIcon
            sx={{
              fontSize: 20,
              color: colors.primary500,
              opacity: 0.7,
              fontWeight: 900,
              lineHeight: "20px",
            }}
          />
        </Box>
      </Tooltip>
    </Stack>
  );
};

export default Actions;
